import React from 'react';
import PropTypes from 'prop-types';
import '../../../styles/core.scss';
import AssignedTeacherInfo from '../../assigned-teacher-info/index';

const AssignedTeacherFormatter = ({ value, handleOnAssignTeacher, dependentValues }) => (
    <AssignedTeacherInfo
        assignedTeachers={value}
        dependentValues={dependentValues}
        handleOnAssignTeacher={handleOnAssignTeacher} />
);

AssignedTeacherFormatter.propTypes = {
    value: PropTypes.array,
    dependentValues: PropTypes.object,
    handleOnAssignTeacher: PropTypes.func
};

export default AssignedTeacherFormatter;



// WEBPACK FOOTER //
// ./app/components/formatters/assigned-teacher-formatter/index.js